import axios from "axios";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import geografiaFunciones from "../function/geografia.Funciones";

const MODULO = "EntesConformadores";

const normalizarTexto = (texto = "") =>
  texto
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

const RegistrarEnteConformador = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [cargandoInicial, setCargandoInicial] = useState(false);

  const isEdit = useMemo(() => Boolean(id), [id]);

  const [nitEnteconformador, setNitEnteconformador] = useState("");
  const [coddaneEnteconformador, setCoddaneEnteconformador] = useState("");
  const [nombreEnteconformador, setNombreEnteconformador] = useState("");
  const [direccionEnteconformador, setDireccionEnteconformador] = useState("");
  const [telefono1Enteconformador, setTelefono1Enteconformador] = useState("");
  const [telefono2Enteconformador, setTelefono2Enteconformador] = useState("");
  const [correoEnteconformador, setCorreoEnteconformador] = useState("");
  const [zonaEnteconformador, setZonaEnteconformador] = useState("");

  const [paises, setPaises] = useState([]);
  const [estados, setEstados] = useState([]);
  const [ciudades, setCiudades] = useState([]);

  const [idPais, setIdPais] = useState("");
  const [idEstado, setIdEstado] = useState("");
  const [idCiudad, setIdCiudad] = useState("");

  const [paisSeleccionado, setPaisSeleccionado] = useState(null);
  const [estadoSeleccionado, setEstadoSeleccionado] = useState(null);
  const [ciudadSeleccionada, setCiudadSeleccionada] = useState(null);

  const authConfig = useCallback(() => {
    const token = localStorage.getItem("token");

    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  }, []);

  const getModuloEntes = () => {
    try {
      const permisosStorage = localStorage.getItem("permisos");
      const usuarioStorage = localStorage.getItem("usuario");
      const userStorage = localStorage.getItem("user");
      const usuariosStorage = localStorage.getItem("usuarios");

      const permisosData = permisosStorage
        ? JSON.parse(permisosStorage)
        : usuarioStorage
        ? JSON.parse(usuarioStorage)
        : userStorage
        ? JSON.parse(userStorage)
        : usuariosStorage
        ? JSON.parse(usuariosStorage)
        : {};

      const modulos = Array.isArray(permisosData)
        ? permisosData
        : permisosData?.modulos ||
          permisosData?.permisos ||
          permisosData?.usuario?.modulos ||
          permisosData?.usuario?.permisos ||
          permisosData?.user?.modulos ||
          permisosData?.user?.permisos ||
          [];

      const moduloBuscado = normalizarTexto(MODULO);

      return (
        modulos.find((modulo) => {
          const nombre =
            modulo?.nombreModulo || modulo?.modulo || modulo?.nombre || "";

          return normalizarTexto(nombre) === moduloBuscado;
        }) || {}
      );
    } catch (error) {
      console.error("Error leyendo permisos:", error);
      return {};
    }
  };

  const moduloEntes = useMemo(() => getModuloEntes(), []);

  const puedeLeer =
    moduloEntes?.puedeLeer === true ||
    moduloEntes?.leer === true ||
    moduloEntes?.ver === true ||
    moduloEntes?.listar === true ||
    moduloEntes?.read === true ||
    moduloEntes?.view === true;

  const puedeCrear =
    moduloEntes?.puedeCrear === true ||
    moduloEntes?.crear === true ||
    moduloEntes?.create === true;

  const puedeActualizar =
    moduloEntes?.puedeActualizar === true ||
    moduloEntes?.actualizar === true ||
    moduloEntes?.editar === true ||
    moduloEntes?.update === true;

  const puedeGuardarFormulario = isEdit ? puedeActualizar : puedeCrear;

  const manejarErrorSesion = useCallback(
    (error) => {
      if (error?.response?.status === 401) {
        Swal.fire({
          icon: "warning",
          title: "Sesión expirada",
          text: "Por favor inicia sesión nuevamente.",
          confirmButtonText: "Aceptar",
        }).then(() => {
          localStorage.removeItem("token");
          navigate("/", { replace: true });
        });

        return true;
      }

      return false;
    },
    [navigate]
  );

  const selectStyles = useMemo(
    () => ({
      container: (base) => ({ ...base, width: "100%" }),
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      menu: (base) => ({ ...base, zIndex: 9999 }),
      control: (base, state) => ({
        ...base,
        minHeight: 38,
        borderColor: state.isFocused ? "#86b7fe" : base.borderColor,
        boxShadow: state.isFocused
          ? "0 0 0 .25rem rgba(13,110,253,.15)"
          : "none",
      }),
    }),
    []
  );

  const paisOptions = useMemo(
    () =>
      Array.from(
        new Map(
          (paises || []).map((p) => [
            p.idPais,
            {
              value: String(p.idPais),
              label: p.nombrePais,
            },
          ])
        ).values()
      ).sort((a, b) =>
        a.label.localeCompare(b.label, "es", {
          sensitivity: "base",
        })
      ),
    [paises]
  );

  const estadoOptions = useMemo(
    () =>
      Array.from(
        new Map(
          (estados || []).map((e) => [
            e.idEstado,
            {
              value: String(e.idEstado),
              label: e.nombreEstado,
            },
          ])
        ).values()
      ).sort((a, b) =>
        a.label.localeCompare(b.label, "es", {
          sensitivity: "base",
        })
      ),
    [estados]
  );

  const ciudadOptions = useMemo(
    () =>
      Array.from(
        new Map(
          (ciudades || []).map((c) => [
            c.idCiudad,
            {
              value: String(c.idCiudad),
              label: c.nombreCiudad,
            },
          ])
        ).values()
      ).sort((a, b) =>
        a.label.localeCompare(b.label, "es", {
          sensitivity: "base",
        })
      ),
    [ciudades]
  );

  const cleanData = useCallback(() => {
    setNitEnteconformador("");
    setCoddaneEnteconformador("");
    setNombreEnteconformador("");
    setDireccionEnteconformador("");
    setTelefono1Enteconformador("");
    setTelefono2Enteconformador("");
    setCorreoEnteconformador("");
    setZonaEnteconformador("");

    setIdPais("");
    setIdEstado("");
    setIdCiudad("");

    setPaisSeleccionado(null);
    setEstadoSeleccionado(null);
    setCiudadSeleccionada(null);

    setEstados([]);
    setCiudades([]);
  }, []);

  useEffect(() => {
    const cargarDatosBase = async () => {
      try {
        setCargandoInicial(true);

        const paisesData = await geografiaFunciones.obtenerPaises();

        setPaises(paisesData || []);
      } catch (error) {
        console.error("Error al cargar países:", error);
      } finally {
        setCargandoInicial(false);
      }
    };

    cargarDatosBase();
  }, []);

  const getData = useCallback(async () => {
    if (isEdit && !puedeLeer) {
      cleanData();
      return;
    }

    try {
      setLoading(true);

      const { data } = await axios.get(`/api/ente/listid/${id}`, authConfig());

      if (!data?.ok) return;

      const ente = data.enteConformador;

      setNitEnteconformador(ente?.nitEnteconformador || "");
      setCoddaneEnteconformador(ente?.coddaneEnteconformador || "");
      setNombreEnteconformador(ente?.nombreEnteconformador || "");
      setDireccionEnteconformador(ente?.direccionEnteconformador || "");
      setTelefono1Enteconformador(ente?.telefono1Enteconformador || "");
      setTelefono2Enteconformador(ente?.telefono2Enteconformador || "");
      setCorreoEnteconformador(ente?.correoEnteconformador || "");
      setZonaEnteconformador(ente?.zonaEnteconformador || "");

      setIdPais(String(ente?.idPais || ""));
      setIdEstado(String(ente?.idEstado || ""));
      setIdCiudad(String(ente?.idCiudad || ""));

      const [estadosData, ciudadesData] = await Promise.all([
        ente?.idPais
          ? geografiaFunciones.obtenerEstadosPorPais(ente.idPais)
          : Promise.resolve([]),
        ente?.idEstado
          ? geografiaFunciones.obtenerCiudadesPorEstado(ente.idEstado)
          : Promise.resolve([]),
      ]);

      const estadosUnicos = Array.from(
        new Map((estadosData || []).map((e) => [e.idEstado, e])).values()
      );

      const ciudadesUnicas = Array.from(
        new Map((ciudadesData || []).map((c) => [c.idCiudad, c])).values()
      );

      setEstados(estadosUnicos);
      setCiudades(ciudadesUnicas);

      const paisObj = paises.find(
        (p) => String(p.idPais) === String(ente?.idPais)
      );

      setPaisSeleccionado(
        paisObj
          ? { value: String(paisObj.idPais), label: paisObj.nombrePais }
          : null
      );

      const estadoObj = estadosUnicos.find(
        (e) => String(e.idEstado) === String(ente?.idEstado)
      );

      setEstadoSeleccionado(
        estadoObj
          ? {
              value: String(estadoObj.idEstado),
              label: estadoObj.nombreEstado,
            }
          : null
      );

      const ciudadObj = ciudadesUnicas.find(
        (c) => String(c.idCiudad) === String(ente?.idCiudad)
      );

      setCiudadSeleccionada(
        ciudadObj
          ? {
              value: String(ciudadObj.idCiudad),
              label: ciudadObj.nombreCiudad,
            }
          : null
      );
    } catch (error) {
      console.error("Error al cargar ente conformador:", error);

      if (manejarErrorSesion(error)) return;

      Swal.fire("Error", "No se pudo cargar el ente conformador", "error");
    } finally {
      setLoading(false);
    }
  }, [
    id,
    isEdit,
    puedeLeer,
    paises,
    authConfig,
    cleanData,
    manejarErrorSesion,
  ]);

  useEffect(() => {
    if (id && !cargandoInicial && paises.length > 0) {
      getData();
    }
  }, [id, cargandoInicial, paises, getData]);

  const handlePaisChange = async (selectedOption) => {
    setPaisSeleccionado(selectedOption);

    const newIdPais = selectedOption?.value ? String(selectedOption.value) : "";

    setIdPais(newIdPais);
    setEstadoSeleccionado(null);
    setCiudadSeleccionada(null);
    setIdEstado("");
    setIdCiudad("");
    setEstados([]);
    setCiudades([]);

    if (newIdPais) {
      const estadosData = await geografiaFunciones.obtenerEstadosPorPais(
        newIdPais
      );

      const estadosUnicos = Array.from(
        new Map((estadosData || []).map((e) => [e.idEstado, e])).values()
      );

      setEstados(estadosUnicos);
    }
  };

  const handleEstadoChange = async (selectedOption) => {
    setEstadoSeleccionado(selectedOption);

    const newIdEstado = selectedOption?.value
      ? String(selectedOption.value)
      : "";

    setIdEstado(newIdEstado);
    setCiudadSeleccionada(null);
    setIdCiudad("");
    setCiudades([]);

    if (newIdEstado) {
      const ciudadesData = await geografiaFunciones.obtenerCiudadesPorEstado(
        newIdEstado
      );

      const ciudadesUnicas = Array.from(
        new Map((ciudadesData || []).map((c) => [c.idCiudad, c])).values()
      );

      setCiudades(ciudadesUnicas);
    }
  };

  const handleCiudadChange = (selectedOption) => {
    setCiudadSeleccionada(selectedOption);
    setIdCiudad(selectedOption?.value ? String(selectedOption.value) : "");
  };

  const saveEnteConformador = async () => {
    if (!puedeCrear) {
      Swal.fire(
        "Sin permisos",
        "No tiene permisos para registrar entes conformadores.",
        "warning"
      );
      return;
    }

    try {
      setLoading(true);

      const newEnteConformador = {
        nitEnteconformador,
        coddaneEnteconformador,
        nombreEnteconformador,
        direccionEnteconformador,
        telefono1Enteconformador,
        telefono2Enteconformador,
        correoEnteconformador,
        zonaEnteconformador,
        idPais,
        idEstado,
        idCiudad,
      };

      const { data } = await axios.post(
        "/api/ente/add",
        newEnteConformador,
        authConfig()
      );

      if (data?.ok === false) {
        return Swal.fire(
          "Error",
          data?.message || "No se pudo registrar.",
          "error"
        );
      }

      await Swal.fire({
        icon: "success",
        title: "El Ente Conformador ha sido registrado con éxito",
        showConfirmButton: false,
        timer: 1500,
      });

      cleanData();
      navigate("/enteconformador/ente/");
    } catch (error) {
      console.error("Error en saveEnteConformador:", error);

      if (manejarErrorSesion(error)) return;

      const msg =
        error.response?.data?.message || "Error al guardar el Ente Conformador";

      Swal.fire("Error", msg, "error");
    } finally {
      setLoading(false);
    }
  };

  const updateEnteConformador = async () => {
    if (!puedeActualizar) {
      Swal.fire(
        "Sin permisos",
        "No tiene permisos para actualizar entes conformadores.",
        "warning"
      );
      return;
    }

    if (!puedeLeer) {
      Swal.fire(
        "Sin permisos",
        "No tiene permisos para leer la información del ente conformador.",
        "warning"
      );
      return;
    }

    try {
      setLoading(true);

      const enteConformadorUpdate = {
        nitEnteconformador,
        coddaneEnteconformador,
        nombreEnteconformador,
        direccionEnteconformador,
        telefono1Enteconformador,
        telefono2Enteconformador,
        correoEnteconformador,
        zonaEnteconformador,
        idPais,
        idEstado,
        idCiudad,
      };

      const { data } = await axios.put(
        `/api/ente/update/${id}`,
        enteConformadorUpdate,
        authConfig()
      );

      if (data?.ok === false) {
        return Swal.fire(
          "Error",
          data?.message || "No se pudo actualizar.",
          "error"
        );
      }

      await Swal.fire({
        icon: "success",
        title: data?.message || "Ente Conformador actualizado exitosamente",
        showConfirmButton: false,
        timer: 1500,
      });

      cleanData();
      navigate("/enteconformador/ente");
    } catch (error) {
      console.error("Error al actualizar el EnteConformador:", error);

      if (manejarErrorSesion(error)) return;

      const msg =
        error.response?.data?.message ||
        "No se pudo actualizar el EnteConformador";

      Swal.fire("Error", msg, "error");
    } finally {
      setLoading(false);
    }
  };

  const actions = async (e) => {
    e.preventDefault();

    if (loading || cargandoInicial) return;

    isEdit ? await updateEnteConformador() : await saveEnteConformador();
  };

  const handleCancel = () => {
    cleanData();
    navigate("/enteconformador/ente/");
  };

  const cargando = loading || cargandoInicial;

  if (isEdit && !puedeLeer) {
    return (
      <div>
        <div className="container-fluid px-2 px-md-4 py-4">
          <div className="bg-white border rounded-4 shadow-sm p-4">
            <div className="text-center text-secondary py-5">
              <div className="display-6 mb-3">
                <i className="fa-solid fa-lock"></i>
              </div>

              <h5 className="fw-semibold text-dark">Sin permiso de lectura</h5>

              <p className="mb-4">
                No tienes permisos para consultar este ente conformador.
              </p>

              <button
                className="btn btn-outline-dark"
                type="button"
                onClick={() => navigate("/enteconformador/ente")}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i>
                Volver
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!isEdit && !puedeCrear) {
    return (
      <div>
        <div className="container-fluid px-2 px-md-4">
          <div className="bg-white border rounded-4 shadow-sm p-4">
            <div className="text-center text-secondary py-5">
              <div className="display-6 mb-3">
                <i className="fa-solid fa-lock"></i>
              </div>

              <h5 className="fw-semibold text-dark">Sin permiso de creación</h5>

              <p className="mb-4">
                No tienes permisos para registrar entes conformadores.
              </p>

              <button
                className="btn btn-outline-dark"
                type="button"
                onClick={() => navigate("/enteconformador/ente")}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i>
                Volver
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isEdit && !puedeActualizar) {
    return (
      <div>
        <div className="container-fluid px-2 px-md-4">
          <div className="bg-white border rounded-4 shadow-sm p-4">
            <div className="text-center text-secondary py-5">
              <div className="display-6 mb-3">
                <i className="fa-solid fa-lock"></i>
              </div>

              <h5 className="fw-semibold text-dark">
                Sin permiso de actualización
              </h5>

              <p className="mb-4">
                No tienes permisos para editar entes conformadores.
              </p>

              <button
                className="btn btn-outline-dark"
                type="button"
                onClick={() => navigate("/enteconformador/ente")}
              >
                <i className="fa-solid fa-arrow-rotate-left me-2"></i>
                Volver
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="container-fluid px-2 px-md-4">
        <div className="bg-white border rounded-4 shadow-sm overflow-hidden">
          <div className="px-3 px-md-4 py-3 border-bottom bg-white">
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
              <div>
                <h5 className="mt-2 mb-1 fw-semibold">
                  {isEdit
                    ? "Editar Ente Conformador"
                    : "Registrar Ente Conformador"}
                </h5>

                <small className="text-secondary">
                  Completa la información del ente y su ubicación geográfica.
                </small>
              </div>

              <div className="d-flex gap-2 flex-wrap">
                <button
                  type="button"
                  className="btn btn-outline-dark"
                  onClick={() => navigate("/enteconformador/ente")}
                  disabled={cargando}
                  title="Volver"
                >
                  <i className="fa-solid fa-arrow-rotate-left me-2"></i>
                  Volver
                </button>
              </div>
            </div>
          </div>

          <div className="p-3 p-md-4">
            {cargando && (
              <div className="text-center text-secondary py-3">
                <div className="spinner-border" role="status" />
                <div className="mt-2">
                  {loading
                    ? isEdit
                      ? "Cargando información del ente conformador…"
                      : "Procesando…"
                    : "Cargando datos base…"}
                </div>
              </div>
            )}

            <form
              id="form-ente"
              onSubmit={actions}
              className="needs-validation"
              noValidate
            >
              <div className="row g-3">
                <div className="col-12 col-md-3">
                  <label className="form-label fw-semibold">DANE</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: 05001"
                    value={coddaneEnteconformador}
                    onChange={(e) => setCoddaneEnteconformador(e.target.value)}
                    required
                    disabled={cargando}
                  />
                </div>

                <div className="col-12 col-md-3">
                  <label className="form-label fw-semibold">NIT</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: 900123456-7"
                    value={nitEnteconformador}
                    onChange={(e) => setNitEnteconformador(e.target.value)}
                    required
                    disabled={cargando}
                  />
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label fw-semibold">Nombre</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: Institución Educativa…"
                    value={nombreEnteconformador}
                    onChange={(e) => setNombreEnteconformador(e.target.value)}
                    required
                    disabled={cargando}
                  />
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label fw-semibold">Dirección</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: Calle 10 # 20-30"
                    value={direccionEnteconformador}
                    onChange={(e) =>
                      setDireccionEnteconformador(e.target.value)
                    }
                    required
                    disabled={cargando}
                  />
                </div>

                <div className="col-12 col-md-3">
                  <label className="form-label fw-semibold">Teléfono 1</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ej: 6041234567"
                    value={telefono1Enteconformador}
                    onChange={(e) =>
                      setTelefono1Enteconformador(e.target.value)
                    }
                    required
                    disabled={cargando}
                  />
                </div>

                <div className="col-12 col-md-3">
                  <label className="form-label fw-semibold">Teléfono 2</label>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Opcional"
                    value={telefono2Enteconformador}
                    onChange={(e) =>
                      setTelefono2Enteconformador(e.target.value)
                    }
                    disabled={cargando}
                  />
                </div>

                <div className="col-12 col-md-4">
                  <label className="form-label fw-semibold">País</label>

                  <Select
                    options={paisOptions}
                    value={paisSeleccionado}
                    onChange={handlePaisChange}
                    placeholder="Seleccione un país"
                    isClearable
                    styles={selectStyles}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    isDisabled={cargando}
                  />
                </div>

                <div className="col-12 col-md-4">
                  <label className="form-label fw-semibold">
                    Estado / Departamento
                  </label>

                  <Select
                    options={estadoOptions}
                    value={estadoSeleccionado}
                    onChange={handleEstadoChange}
                    placeholder="Seleccione un estado"
                    isClearable
                    isDisabled={cargando || !paisSeleccionado}
                    styles={selectStyles}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>

                <div className="col-12 col-md-4">
                  <label className="form-label fw-semibold">Ciudad</label>

                  <Select
                    options={ciudadOptions}
                    value={ciudadSeleccionada}
                    onChange={handleCiudadChange}
                    placeholder="Seleccione una ciudad"
                    isClearable
                    isDisabled={cargando || !estadoSeleccionado}
                    styles={selectStyles}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>

                <div className="col-12 col-md-8">
                  <label className="form-label fw-semibold">
                    Correo Electrónico
                  </label>

                  <input
                    type="email"
                    className="form-control"
                    placeholder="Ej: correo@dominio.com"
                    value={correoEnteconformador}
                    onChange={(e) => setCorreoEnteconformador(e.target.value)}
                    disabled={cargando}
                  />
                </div>

                <div className="col-12 col-md-4">
                  <label className="form-label fw-semibold">Zona</label>

                  <select
                    className="form-select"
                    value={zonaEnteconformador}
                    onChange={(e) => setZonaEnteconformador(e.target.value)}
                    required
                    disabled={cargando}
                  >
                    <option value="">Seleccione…</option>
                    <option value="urbano">Urbano</option>
                    <option value="rural">Rural</option>
                  </select>
                </div>

                <div className="col-12 pt-2">
                  <div className="d-flex flex-wrap gap-2 justify-content-end">
                    <button
                      type="button"
                      className="btn btn-outline-dark"
                      onClick={cleanData}
                      disabled={cargando}
                      title="Limpiar"
                    >
                      <i className="fa-solid fa-eraser me-2"></i>
                      Limpiar
                    </button>

                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      onClick={handleCancel}
                      disabled={cargando}
                    >
                      <i className="fa-solid fa-xmark me-2"></i>
                      Cancelar
                    </button>

                    {puedeGuardarFormulario && (
                      <button
                        type="submit"
                        form="form-ente"
                        className="btn btn-dark"
                        disabled={cargando}
                        title={isEdit ? "Actualizar" : "Guardar"}
                      >
                        <i
                          className={`fa-solid ${
                            cargando ? "fa-spinner fa-spin" : "fa-floppy-disk"
                          } me-2`}
                        ></i>

                        {cargando
                          ? isEdit
                            ? "Actualizando…"
                            : "Guardando…"
                          : isEdit
                          ? "Actualizar"
                          : "Guardar"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>

            {!puedeGuardarFormulario && (
              <div className="alert alert-warning mt-3 mb-0">
                <i className="fa-solid fa-lock me-2"></i>
                No tienes permiso para {isEdit ? "actualizar" : "crear"} entes
                conformadores.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrarEnteConformador;